export enum IncludeDeptType {
    MY_SCHEDULE = "my_schedule",
    MY_DEPARTMENT = "my_department", 
    ALL = "all"
}
